import { MessagePaths, useMessagesTranslation } from '@shared/i18n';
import { CampaignResources } from '../types/CampaignResources';

export const useCampaignTranslation = () => useMessagesTranslation<CampaignResources>();

export type CampaignMessageKey = MessagePaths<CampaignResources>;

export const useCampaignTFunction = () => useCampaignTranslation().t;

export type CampaignTFunction = ReturnType<typeof useCampaignTFunction>;
